class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.js-tabs li');
    this.contents = document.querySelectorAll('.js-tab-content');
    this.tabList = document.querySelector('.tabs [role="tablist"]');
    this.tabFocus = 0
  }
  init() {
    if (this.tabs.length > 0) {
      this.bindEvents();
      this.tabsByHashPathActivation();
    }
  }
  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        this.handleTabActivation(e);
      });
       tab.addEventListener('keydown', (e) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault();
            this.handleTabActivation(e);
        }
      }); 
      
    });
    if (this.tabList && this.tabs) {
        this.tabs.forEach((tab, i) => {
            tab.setAttribute('tabindex', i === 0 ? 0 : -1)
        })
        this.tabList.addEventListener('keydown', (e) => {this.handleKeyboardNavigation(e)})
    }
  }
  
  handleTabActivation(e) {
    e.currentTarget.classList.add('is-active');
    e.currentTarget.setAttribute('aria-selected', 'true');
    
    const targetId = e.currentTarget.dataset.target;
    
    this.tabs.forEach((tab) => {
      if (tab !== e.currentTarget) {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      }
    });
    
    this.contents.forEach((content) => {
      if (content.id == targetId) {
        content.classList.add('is-active');
        content.setAttribute('aria-hidden', 'false');
      } else {
        content.classList.remove('is-active');
        content.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /**
   * This method will click on the content tab in dependency which hash string comes in url
   */
  tabsByHashPathActivation() {
    const tabHash = window.location.hash.slice(1);

    if (tabHash.length > 0) {
      const tabElm = document.querySelector('[data-target="' + tabHash + '"]');

       if (tabElm) {
        tabElm.click();
      } 
    }
  }

  handleKeyboardNavigation(e) {
    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        this.tabs[this.tabFocus].setAttribute("tabindex", -1);
        if (e.key === "ArrowRight") {
          this.tabFocus++;
          if (this.tabFocus >= this.tabs.length) {
            this.tabFocus = 0;
          }
        } else if (e.key === "ArrowLeft") {
          this.tabFocus--;
          if (this.tabFocus < 0) {
            this.tabFocus = this.tabs.length - 1;
          }
        }

  
        this.tabs[this.tabFocus].setAttribute("tabindex", 0);
        this.tabs[this.tabFocus].focus();
      }
  }
}

export default new Tabs();
